var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, Children } from 'react';
import styled from 'styled-components';
const TableRowStyle = styled.tr `
  color: ${props => props.theme.utils.getColor(props.color)};
  font-size: ${props => props.theme.utils.getSize(props.size)};
  display: table-row;
  & > * {
    padding: ${props => props.theme.paddingsMargins.themePadding};
  }
`;
const TableRow = (_a) => {
    var { stickyHeader, children, color = 'dark', size = 'article' } = _a, props = __rest(_a, ["stickyHeader", "children", "color", "size"]);
    const cloneElementData = function (element) {
        return cloneElement(element, { stickyHeader });
    };
    let elements = Children.toArray(children);
    if (elements.length === 1) {
        elements = cloneElement(elements[0], { stickyHeader });
    }
    else if (elements.length > 0) {
        elements = Children.map(children, cloneElementData);
    }
    return _jsx(TableRowStyle, Object.assign({ color: color, size: size }, props, { children: stickyHeader ? elements : children }));
};
export default TableRow;
